import clsx from 'clsx';
import React, { useCallback, useState } from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';

import EditTagInput from '../EditTagInput/EditTagInput';
import { getDisplayAvatar, getDisplayLabel, getFullLabel } from '../Helper';

const DisplayTag = ({
  tag,
  tags,
  index,
  tagKey,
  editMode,
  onRemove,
  onUpdate,
  selectorKey = 'selectedUsers',
}) => {
  const avatar = getDisplayAvatar(tag, selectorKey, '15px', '15px', '10px');
  const fullLabel = getFullLabel(tag);
  const displayLabel = getDisplayLabel(tag);
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = useCallback(() => {
    setIsClicked(true);
  }, [tag, tags]);

  const handleRemove = useCallback(
    (e) => {
      e.stopPropagation();
      onRemove(tag);
    },
    [tag, tags]
  );

  const handleUpdateTag = useCallback(
    (newTagValue) => {
      if (!newTagValue) {
        setIsClicked(false);
        return;
      }

      onUpdate({
        tags,
        oldTag: tag,
        newTagValue,
      });
      setIsClicked(false);
    },
    [tags, tags, editMode.options]
  );

  if (isClicked) {
    return (
      <EditTagInput
        tagKey={editMode.tagKey}
        options={editMode.options}
        defaultValue={tag.value}
        optionsTotalCount={editMode.optionsTotalCount}
        tags={editMode.tags}
        defaultTags={[]}
        validateInput={editMode.validateInput}
        onInputChange={editMode.onInputChange}
        onLoadMore={editMode.onLoadMore}
        onClickTag={handleUpdateTag}
      />
    );
  }

  return (
    <React.Fragment>
      <div
        className={clsx(
          'tw-group',
          'tw-flex tw-items-center',
          'tw-border-solid tw-border-[1px] tw-rounded-[3px]',
          'tw-px-[10px] tw-py-[3px] tw-mr-[5px] tw-mb-[5px]',
          'tw-font-brandonTextMedium',
          'tw-leading-[20px]',
          tag.valid && !tag.bounce
            ? 'tw-text-cfo-blue-700 tw-border-cfo-blue-300 tw-bg-cfo-blue-200'
            : 'tw-text-cfo-red-400 tw-border-cfo-red-400 tw-bg-cfo-red-100'
        )}
        key={tag.value}
        role="button"
        tabIndex={0}
        data-tooltip-id={`tooltip_member_${tagKey}_${index}`}
        onClick={handleClick}
        onKeyDown={handleClick}
      >
        {avatar}
        <span>{displayLabel}</span>

        <Button
          className={clsx(
            'container--clearIcon',
            'tw-group',
            'tw-flex tw-items-center',
            'tw-mr-0 tw-p-0 tw-ml-[5px]',
            tag.valid && !tag.bounce ? 'tw-text-cfo-blue-700' : 'tw-text-cfo-red-400'
          )}
          onClick={handleRemove}
        >
          <Icon className={clsx('tw-text-[15px]')} icon={ICONS.cancel} />
        </Button>

        <Tooltip id={`tooltip_member_${tagKey}_${index}`} place="bottom" effect="solid">
          {fullLabel}
        </Tooltip>
      </div>
    </React.Fragment>
  );
};

export default DisplayTag;
